import { HttpContextToken } from '@angular/common/http';

// Public login requests must work even when stored credentials have expired.
export const PUBLIC_LOGIN_REQUEST = new HttpContextToken<boolean>(() => false);
